const PrivacyPolicy = () => {
  return (
    <iframe
      src="https://macodi-asset.s3.ap-northeast-2.amazonaws.com/macodi_privacy_policy.pdf"
      width="100%"
      height="100%"
      title="개인정보처리방침"
    />
  );
};

export default PrivacyPolicy;
